import React from "react";
import ButtonQuizLibrary from "../buttons/ButtonQuizLibrary";
import ButtonQuizCreate from "../buttons/ButtonQuizCreate";

const TextBanTeamQuiz = () => {

  return (
    <div style={{
      paddingBottom: "320px",
      marginTop: "40px",
      width: "100%",
      textAlign: "center",
      fontSize: "1.2rem"
    }}>

      <div style={{
        fontSize: "3rem",
        fontWeight: "600",
        lineHeight: "3rem",
        color: "red"
      }}>
        Доступ к этому квизу<br />
        заблокирован
      </div>
      <div style={{ marginTop: "10px" }}>
        до тех пор,<br />
        пока админ команды не повысит свой<br />
        статус пользователя.
      </div>
      <div style={{ marginTop: "35px" }}>
        Ищите доступные квизы в БИБЛИОТЕКЕ КВИЗОВ<br />
        или создайте свой.
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "20px"
        }}
      >
        <ButtonQuizLibrary />
      </div>

      <div
        style={{
          textAlign: "center",
          marginTop: "10px"
        }}
      >
        <ButtonQuizCreate />
      </div>
    </div>
  )
}

export default TextBanTeamQuiz